import { render, staticRenderFns } from "./Fanchart.vue?vue&type=template&id=0dcf8fcc&scoped=true&"
import script from "./Fanchart.vue?vue&type=script&lang=js&"
export * from "./Fanchart.vue?vue&type=script&lang=js&"
import style0 from "./Fanchart.vue?vue&type=style&index=0&id=0dcf8fcc&langg=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf8fcc",
  null
  
)

export default component.exports